import React from 'react';
import { Modal, Button, Container, Row, Col, Form } from 'react-bootstrap';

const AssetViewModal = ({ item, show, handleClose }) => {
  if (!item || !item.asset) {
    return null; // safely handle if item or asset is missing
  }

  const { asset } = item;

  return (
    <Modal className="fade" show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-info-circle"></i> Asset Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row className="mb-2">
            <Col md={6}>
              <Form.Label><strong>Asset Name</strong></Form.Label>
              <Form.Control value={asset.name} readOnly />
            </Col>
            <Col md={6}>
              <Form.Label><strong>Description</strong></Form.Label>
              <Form.Control value={asset.description} readOnly />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md={6}>
              <Form.Label><strong>Category</strong></Form.Label>
              <Form.Control value={asset.category?.name || ''} readOnly />
            </Col>
            <Col md={6}>
              <Form.Label><strong>Unit</strong></Form.Label>
              <Form.Control value={asset.unit?.name || ''} readOnly />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md={6}>
              <Form.Label><strong>Serial Number</strong></Form.Label>
              <Form.Control value={asset.serialNumber} readOnly />
            </Col>
            <Col md={6}>
              <Form.Label><strong>Purchase Date</strong></Form.Label>
              <Form.Control value={new Date(asset.purchaseDate).toLocaleDateString()} readOnly />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md={6}>
              <Form.Label><strong>Status</strong></Form.Label>
              <Form.Control value={asset.status} readOnly />
            </Col>
          </Row>
          <hr />
          <h5>Master Part Details</h5>
          <Row className="mb-2">
            <Col md={6}>
              <Form.Label><strong>Part No</strong></Form.Label>
              <Form.Control value={asset.masterPart?.partNo || ''} readOnly />
            </Col>
            <Col md={6}>
              <Form.Label><strong>Master Category</strong></Form.Label>
              <Form.Control value={asset.masterPart?.category?.name || ''} readOnly />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md={6}>
              <Form.Label><strong>Master Unit</strong></Form.Label>
              <Form.Control value={asset.masterPart?.unit?.name || ''} readOnly />
            </Col>
            <Col md={6}>
              <Form.Label><strong>Active</strong></Form.Label>
              <Form.Control value={asset.masterPart?.active ? 'Yes' : 'No'} readOnly />
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssetViewModal;
